import React from 'react';
import PropTypes from 'prop-types';
import Validation from 'infrastructure/js/components/controls/controlsValidations.js';
import Combobox from 'infrastructure/js/components/controls/Combobox/combobox.js';
import Parse from 'infrastructure/js/components/controls/controlsParse';
import Format from 'infrastructure/js/components/controls/controlsFormat';
import { enumTypes, getEnumValue } from '../../../../../../utils/enumHelper';
import withPortal from 'infrastructure/js/components/HOCs/withPortal/withPortal';

import './operationListItem.scss';

const ComboboxPortal = withPortal(Combobox);

export default class OperationListItem extends React.PureComponent {
  onChangeCallback = (value, oldValue) => {
    this.props.onChangeCallback?.(value, oldValue, this.props.index);
  };

  stationTypeSpecificValidation = (value, allValues) => {
    const { name, stationType, labels, touch } = this.props;

    if (!name?.includes('secondaryOperations')) {
      return undefined;
    }

    const OPERATION = enumTypes.OPERATION_TYPE;
    const LOCATION = enumTypes.LOCATION_TYPE;

    const operationTypes = {
      CUT: getEnumValue(OPERATION)('CUT'),
      KIT: getEnumValue(OPERATION)('KIT'),
      SLITTING: getEnumValue(OPERATION)('SLITTING'),
      SPOOLING: getEnumValue(OPERATION)('SPOOLING'),
    };

    const locationRules = {
      [getEnumValue(LOCATION)('KIT')]: [
        operationTypes.CUT,
        operationTypes.SLITTING,
        operationTypes.SPOOLING,
      ],
      [getEnumValue(LOCATION)('CUT')]: [
        operationTypes.KIT,
        operationTypes.SLITTING,
        operationTypes.SPOOLING,
      ],
      [getEnumValue(LOCATION)('CUT_KIT')]: [
        operationTypes.SLITTING,
        operationTypes.SPOOLING,
      ],
      [getEnumValue(LOCATION)('SLITTING_SPOOLING')]: [
        operationTypes.KIT,
        operationTypes.CUT,
      ],
      DEFAULT: Object.values(operationTypes),
    };

    const disallowedOperations =
      locationRules[stationType] || locationRules.DEFAULT;

    const hasConflict = disallowedOperations.some(op =>
      this.isOperationAlreadySelected(op, value, allValues)
    );

    if (hasConflict) {
      touch(`${name}.[operation]`);
      return labels.get('validation.operationType');
    }

    return undefined;
  };

  isOperationAlreadySelected = (operationType, value, allValues) => {
    const selectedOperationType = this.props.getOperationTypeById(value);
    if (selectedOperationType !== operationType) {
      return false;
    }

    return allValues.secondaryOperations.some((item, index) =>
      this.props.getOperationTypeById(item.operation) === operationType &&
      this.props.index !== index
    );
  };


    render() {
        let { options, name } = this.props;

        return (
            <div className='operation-list-item'>
                <ComboboxPortal
                    id={name + '.[operation]'}
                    name={name + '.[operation]'}
                    validate={[Validation.dropdown.required, this.stationTypeSpecificValidation]}
                    options={options}
                    parse={Parse.comboValueOnly()}
                    format={Format.findOptionByValue(options)}
                    onChangeCallback={this.onChangeCallback}
                    isDisabled={this.props.disabled}
                />
            </div>
        );
    }
}

OperationListItem.propTypes = {
    name: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    getOperationTypeById: PropTypes.func,
    stationType: PropTypes.string,
    labels: PropTypes.object,
    options: PropTypes.array,
};
